import { IValuesFilterLogs } from "../LogsContextTypes";

export const valuesDefaultFilterLogs: IValuesFilterLogs = {
  start_data: "",
  end_data: "",
  action: "",
  user: "",
};
